import { INCREASE_DIALOG_COUNTER, DISMISS_DIALOG } from '../actions/actionTypes';

export default function reducers(state = {}, action) {
    switch (action.type) {
        case INCREASE_DIALOG_COUNTER: {
            const stateSurveyType = state[action.payload] || {};
            const myCount = stateSurveyType.count + 1 || 1;

            return { ...state, [action.payload]: { ...state[action.payload], count: myCount } };
        }

        case DISMISS_DIALOG:
            return { ...state, [action.payload]: { ...state[action.payload], dismissed: true } };
        default:
            return state;
    }
}
